// import jQuery
import $, { timers } from "jquery";

// import bootstrap components from node_modules folder
// see https://getbootstrap.com/docs/4.3/getting-started/webpack/
// import 'popper.js';
// import 'bootstrap/js/dist/util';
// import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/tooltip';
import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";
import Hls from 'hls.js';

import { Map, Marker } from "leaflet";
import { MarkerClusterGroup } from "leaflet.markercluster/src";
import { GestureHandling } from "leaflet-gesture-handling";
import {isVisible} from "uikit/src/js/util";

UIkit.use(Icons);

// import demo
// import fooFighters from './demo-modules/foo-fighters';

// on document ready
$(function () {
    var $doc = $(document);
    var map;
    var allrows;
    var markers;
    var contained;
    var myIcon;
    var marker_layer;
    var $oc_elements = [];

    // enable bootstrap tooltips
    //$('[data-toggle="tooltip"]').tooltip();

    // Learn to Fly!
    //console.dir(fooFighters);

    function initMoreContent() {
        // Toggle more-content
        $(document).find(".more-content").hide();
        $(document)
            .find(".more-link")
            .each(function () {
                var l = $(this);
                l.find(".text").html($(this).data("text-closed"));
                l.click(function (e) {
                    e.preventDefault();
                    if (l.hasClass("open")) {
                        l.removeClass("open")
                            .find(".text")
                            .html(l.data("text-closed"))
                            .end()
                            .find(".uk-icon")
                            .attr("uk-icon", "chevron-down")
                            .end()
                            .prev(".more-content")
                            .slideUp(300);
                    } else {
                        l.addClass("open")
                            .find(".text")
                            .html(l.data("text-opened"))
                            .end()
                            .find(".uk-icon")
                            .attr("uk-icon", "chevron-up")
                            .end()
                            .prev(".more-content")
                            .slideDown(300);
                    }
                });
            });
    }

    function initFilter() {


        $('.filter-button').each(function () {
            var $dd = $(this).next('.uk-dropdown');
            $dd.css('width', $(this).outerWidth());
        });

        $('.filter-dropdown[data-uk-dropdown]').on('shown', function (e) {
            // Calculate Widest Span in Dropdown
            var maxWidth = 0;
            var widestSpan = null;
            var $element;
            $(this)
                .find('span')
                .each(function () {
                    $element = $(this);
                    if ($element.width() > maxWidth) {
                        maxWidth = $element.width();
                        widestSpan = $element;
                    }
                });

            if (widestSpan &&

                widestSpan.width() +
                    parseInt($(this).css("padding-left"), 10) <=
                $(this).prev("button").outerWidth()
            ) {
                $(this).css("width", $(this).prev("button").outerWidth());
            }
        });

        $('[data-uk-filter]').on('afterFilter', function (e) {
            //            console.log("afterfilter fertig");
            allrows = $('#projektliste .item:visible'); // als jquery Objekte speichern wegen Attributen
            set_marker(true);
            $('button.filter-button').each(function () {
                $(this).find('.button-title').text($(this).data('title'));
            });
            $('#uk-search-input').val('');
            var $activeFilterControl = $(this).find(
                '[data-uk-filter-control].uk-active'
            );

            $activeFilterControl.each(function (e) {
                var $activeText = $(this).find('a').html(),
                    $button = $(this)
                        .parents('.filter-dropdown')
                        .prev('button'),
                    $dropdown = $(this).parents('.uk-dropdown');
                if ($(this).hasClass('empty')) {
                    $button.find('.button-title').text($button.data('title'));
                } else {
                    $button
                        .find('.button-title')
                        .text(
                            $activeText
                                .replace('&amp;', '&')
                                .replace(/(<([^>]+)>)/gi, '')
                        );
                }
            });

            countItems();


        });

        // Alle nicht sichtbaren Elemente rausfiltern
        UIkit.util.on('.project-detail', 'beforeshow', function () {
            initBrowseOffcanvas(false);
        });

        // Textsuche
        $("#uk-search-input").on("keyup", function () {
            let searchstring = $(this).val().toLowerCase();

            $("#projektliste .item.searchhidden").show();
            $("#projektliste .item").removeClass('searchhidden');

            $("#projektliste .item:visible").each(function () {
              if (-1 == $(this).text().toLowerCase().indexOf(searchstring)) {
                $(this).addClass('searchhidden');
                $(this).hide();
              }
            });
            allrows = $("#projektliste .item:visible"); // als jquery Objekte speichern wegen Attributen
            initBrowseOffcanvas(false);
            set_marker(true);
            countItems();
        });
    } // initFilter

    function countItems() {
        // Counter
        let count = 0;
        $('#projektliste .item').each(function (i, item) {
            if (isVisible(item)) {
                count += 1;
            }
        });

        // Update and reset count
        $('#counter').html(count);
        count = 0;
    }

    function initToggleMore() {
        $doc.find(".more-content").hide();
        $doc.find(".more-link").click(function (e) {
            e.preventDefault();
            $(this)
                .parent(".more-button")
                .prev(".more-content")
                .slideToggle(300)
                .toggleClass("open")
                .end()
                .toggleClass("open");
        });
    }

    /* * * Map Functions  */
    function initMap() {
        var table;
        //    var states;
        if (typeof L !== "undefined" && $("#projektliste .item").length) {
            var geoJsonData = {
                type: "FeatureCollection",
            };
            //        var tiles = L.tileLayer("/?osmtype=carto_light&z={z}&x={x}&y={y}", {
            var tiles = L.tileLayer("/?osmtype=german&z={z}&x={x}&y={y}", {
                maxZoom: 18,
                minZoom: 7,
                attribution:
                    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            });

            map = L.map("mapid", {
                center: [50.6, 9],
                zoom: 8,
                zoomControl: false,
                gestureHandling: true,
            }).addLayer(tiles);

            L.control
                .zoom({
                    position: "topright",
                    zoomInTitle: 'einzoomen',
                    zoomOutTitle: 'auszoomen'
                })
                .addTo(map);

            myIcon = L.divIcon({
                className: "map-icon",
                iconSize: null,
                popupAnchor: [22, 0],
            });

            allrows = $("#projektliste .item:visible"); // als jquery Objekte speichern wegen Attributen

            $(function () {
                L.geoJSON(states, {
                    style: function (feature) {
                        switch (feature.properties.area) {
                            case "Hessen":
                                return {
                                    color: "#939285 ",
                                    fillColor: "#939285 ",
                                    fillOpacity: 0.5,
                                    weight: 0,
                                    opacity: 0,
                                };
                        }
                    },
                }).addTo(map);
            });

            set_marker();
        }

        $('body').on('focus','.leaflet-marker-icon.map-icon',function(e) {
            let elem = $(this);
            let current_id = elem.get(0)._leaflet_id;
            map.eachLayer(function(layer) {
                if (!$.isEmptyObject(layer._icon)) {
                    if (layer._icon._leaflet_id == current_id) {
                        layer.openPopup();
                    }                
                }
            });
        });
    

    }

    function set_marker(clearlayers = false) {
        if (clearlayers) {
            map.eachLayer(function (layer) {
                if (layer instanceof L.MarkerClusterGroup) {
                    map.removeLayer(layer);
                }
            });
        }
        markers = new MarkerClusterGroup({ chunkedLoading: true });
        $(allrows).each(function () {
            let headline = '';
            if ($(this).data("pretitle").indexOf($(this).find(".card-headline").text()) === -1) {
                headline = $(this).find(".card-headline").text() + '<br />';
            }

            var marker = L.marker(
                [$(this).data("latitude"), $(this).data("longitude")],
                {
                    icon: myIcon,
                    data_id: $(this).data("dataid"),
                    alt: $(this).data("pretitle"),
                    title: $(this).data("pretitle"),
                }
            )
                .bindPopup(
                    '<div class="popup">' +
                        $(this).data("pretitle")  + '<br />' +
                        headline +
                        $(this).find(".card-pretitle").text() +
                        "</div>"
                )
                .on("click", function (e) {
                    UIkit.offcanvas('#detail_' + e.target.options.data_id).show();
                })
                .on("mouseover", function (e) {
                    this.openPopup();
                })
                .on("keyup", function (e) {
                    if (e.originalEvent.key == 'Enter') {
                        UIkit.offcanvas('#detail_' + e.target.options.data_id).show();
                    }
                })
                ;
            markers.addLayer(marker);
        });
        marker_layer = map.addLayer(markers);
    }

    /* * * End Map Functions  */

    function initBrowseOffcanvas(init = true) {
        //        $oc_elements = $doc.find(".project-detail");
        set_oc_elements();
        //        console.log($oc_elements);
        var $oc_count = $oc_elements.length;
        var $nav =
            '<div class="offcanvas-nav">\n' +
            '                    <a href="#" class="nav-item nav-prev" aria-label="zum vorherigen Projekt" rel="nofollow" data-uk-toggle>\n' +
            '                        <svg class="icon" aria-hidden="true">\n' +
            '                            <use xlink:href="#icon-arrow-left"></use>\n' +
            "                        </svg>\n" +
            "                    </a>\n" +
            '                    <a href="#" class="nav-item nav-close uk-offcanvas-close " rel="nofollow" aria-label="Detailansicht schließen">\n' +
            '                        <svg class="icon" aria-hidden="true">\n' +
            '                            <use xlink:href="#icon-close"></use>\n' +
            "                        </svg>\n" +
            "                    </a>\n" +
            '                    <a href="#" class="nav-item nav-next" aria-label="zum nächsten Projekt" rel="nofollow" data-uk-toggle>\n' +
            '                        <svg class="icon" aria-hidden="true">\n' +
            '                            <use xlink:href="#icon-arrow-right"></use>\n' +
            "                        </svg>\n" +
            "                    </a>\n" +
            "                </div>";

        $($oc_elements).each(function (i) {
            var $el = $(this);
            let next_id = $($oc_elements[i + 1]).attr("id");
            let prev_id = $($oc_elements[i - 1]).attr("id");

            if (init) {
                $el.find(".uk-offcanvas-bar").prepend($nav);
            }

            var $prev = $el.find(".nav-prev"),
                $next = $el.find(".nav-next");

            $prev.removeClass("uk-hidden");
            $next.removeClass("uk-hidden");

            if (i < 1) {
                $prev.addClass("uk-hidden");
            } else {
                $prev.attr("href", "#" + prev_id);
            }
            if (i === $oc_count - 1) {
                $next.addClass("uk-hidden");
            } else {
                $next.attr("href", "#" + next_id);
            }
        });
    }

    function set_oc_elements() {
        $oc_elements = [];
        $("#projektliste .item").each(function () {
            if ($(this).is(":visible")) {
                $oc_elements.push($("#detail_" + $(this).data("dataid")));
            }
        });
    }

    function initToggleCheckboxes() {
        $('.uk-checkbox[data-toggle]').click(function () {
            let $checkAll = $(this),
                $targets = $('#' + $checkAll.data('toggle')).find('.uk-checkbox');

            if ($checkAll.is(':checked') == true) {
                $targets.prop('checked', true);
            } else {
                $targets.prop('checked', false);
            }
        });
    }
    function initToggleNext() {
        $doc.find(".toggle-next +").hide();
        $doc.on('click','.toggle-next', function(e) {
            e.preventDefault();
            $(this)
                .next()
                .slideToggle(300)
                .end()
                .toggleClass("open")
        });
    }

    function initFormular() {
        let filefield = $('#ki-projektbild-upload input[type=file]');
        $('#ki-projektbild-upload').on('click','button',function() {
            $('#ki-projectbild-upload').wrap('<form>');
            $(filefield).closest('form').get(0).reset();
            $('#ki-projectbild-upload').unwrap();
            $('#ki-file-loeschen-button').hide();            
            $('#ki-projektbild-upload .help-block').remove();
            $('#ki-projektbild-upload input[type=hidden]').val('');
        });

        $('#ki-file-loeschen-button').hide();

        if ($('#ki-projektbild-upload .help-block').length) {
            $('#ki-file-loeschen-button').show();
        }

        filefield.on('change',function() {
            $('#ki-file-loeschen-button').hide();
            if (filefield.val()) {
                $('#ki-file-loeschen-button').show();
            }
        });
    }

    function initOffcanvas() {
        $(document).on('click', 'a[data-offcanvas]', function(e) {
            e.preventDefault();

            var targetUrl = $(this).attr('href');
            var offcanvas = $('#detail_offcanvas');
            var contentContainer = offcanvas.find('.offcanvas-content');

            // Lade-Indikator anzeigen
            contentContainer.html('<div class="uk-text-center uk-padding"><div data-uk-spinner></div></div>');

            // Offcanvas öffnen
            UIkit.offcanvas(offcanvas).show();

            // AJAX-Anfrage senden
            $.ajax({
                url: targetUrl,
                method: 'GET',
                success: function(response) {
                    // Response in temporäres Element einfügen, um DOM-Parsing zu erleichtern
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = response;

                    // Versuche main-Tag zu finden
                    var mainContent = $(tempDiv).find('main').html();

                    // Falls kein main-Tag, versuche andere Container
                    if (!mainContent) {
                        mainContent = $(tempDiv).find('.main-content, #content, #main-content, article').html();
                    }

                    if (mainContent) {
                        contentContainer.html(mainContent);
                    } else {
                        // Debugging-Info (für Entwicklung)
                        console.log('Geladener Inhalt:', response.substring(0, 500) + '...');
                        contentContainer.html('<div class="uk-alert uk-alert-warning">Der Inhalt konnte nicht geladen werden. Kein <main>-Element gefunden.</div>');
                    }
                },
                error: function(xhr, status, error) {
                    console.error('AJAX-Fehler:', status, error);
                    contentContainer.html('<div class="uk-alert uk-alert-danger">Fehler beim Laden des Inhalts: ' + status + '</div>');
                }
            });
        });
    }

    initMoreContent();
    initFilter();
    initToggleMore();
    initMap();
    initBrowseOffcanvas();
    initToggleCheckboxes();
    initToggleNext();
    initFormular();
    initOffcanvas();
});


decryptEmailaddresses();

function decryptEmailaddresses() {
	// Ersetze E-Mailadressen
	$('span.unicorn').each(function () {
		$(this).replaceWith('@');
	});
	
	// Ersetze mailto-Links
	$('a[href^="javascript:decryptUnicorn"]').each(function () {
	
		// Selektiere Einhorn-Werte
		var emails = $(this).attr('href').match(/\((.*)\)/)[1];

        console.log(emails);
		
		emails = emails
			// ROT13-Transformation
			.replace(/[a-z]/gi, function (s) {
				return String.fromCharCode(s.charCodeAt(0) + (s.toLowerCase() < 'n' ? 13 : -13))
			})
			// Ersetze # durch @
			.replace(/\|/g, '@');
		
		// Ersetze Einhörner
		$(this).attr('href', 'mailto:' + emails);
	});
}


document.addEventListener('DOMContentLoaded', function () {

    /* HLS Video */

    if (Hls && Hls.isSupported()) {

        document.querySelectorAll('video').forEach(video => {
            let videoSource = video.getAttribute('data-video');

            if (videoSource) {
                let hls = new Hls({
                    minAutoBitrate: 5000000 // Set minimum auto bitrate to 3 Mbps
                });
                hls.loadSource(videoSource);
                hls.attachMedia(video);
                hls.on(Hls.Events.MANIFEST_PARSED, function () {
                    video.play();
                });
            }
        });
    }
});
